<div class="matrix_layoutMain container border" v-bind:class="getClassNameContainer">
    <div class="row border">
        <!-- <appLeftSidebar></appLeftSidebar> -->
        <div class="col-md-9">
            <appMainContent></appMainContent>
        </div>
        <div class="col-md-3">
            <appQuantityTable>
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appOtherOptionsTable>
                <appOtherOptionsContainer></appOtherOptionsContainer>
            </appOtherOptionsTable>
            <appOptionsTable>
                <appOptionsContainer></appOptionsContainer>
                <appInputCustomFormatInsert></appInputCustomFormatInsert>
            </appOptionsTable>
        </div>
    </div>    
</div>